import SurveyPage from '../components/SurveyPage.js';
import ProgramInfo from '../components/dev/surveys/ProgramInfo';
import ResponseInfo from '../components/dev/surveys/ResponseInfo';
import QuestionInfo from '../components/dev/surveys/QuestionInfo';
import QuestionInfoButton from '../components/dev/surveys/QuestionInfoButton';
import Hover from '../components/Hover.vue';
import { createApp } from 'vue';
import MutuallyExclusive from '../directives/MutuallyExclusive';

if(document.getElementById('survey-page-instance')){
    const app = createApp({
        components: { 
            SurveyPage ,
            ProgramInfo,
            ResponseInfo,
            QuestionInfo,
            QuestionInfoButton,
            Hover,
        },
        directives: {
            'exclusive': MutuallyExclusive
        },
        // template: "<div>template from survey.js</div>"
    });
    
    app.mount('#survey-page-instance');
}